import React, { FC, useState } from "react";
import { IMensagemAtribuicao } from "@deltasge/marauders-map";
import {
  Box,
  Chip,
  Divider,
  Grid,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import { Plus as PlusIcon } from "mdi-material-ui";

const AtribuicaoComponent: FC<{ atr: IMensagemAtribuicao }> = ({ atr }) => {
  let quem = "Todos os cursos";
  if (atr.turma) quem = atr.turma.tituloTurma;
  else if (atr.serie) quem = `Todas as turmas do(a) ${atr.serie.descricao}`;
  else if (atr.curso) quem = `Todas as séries do ${atr.curso.nome}`;

  let materia = "Todas as matérias";
  if (atr.materia) materia = `Matéria: ${atr.materia.nome}`;

  const {
    aluno,
    responsavel,
    loginExtra,
    professor,
    mensagemAtribuicaoAlunos: maa,
    mensagemAtribuicaoResponsaveis: mar,
    mensagemAtribuicaoLoginsExtras: male,
    mensagemAtribuicaoProfessores: map,
  } = atr;

  let labelAluno = "Todos os alunos";
  let nomeAlunos: React.ReactNode | undefined;
  if (maa && maa.length > 0) {
    labelAluno = `${maa.length} aluno${maa.length > 1 ? "s" : ""} selecionado${
      maa.length > 1 ? "s" : ""
    }`;
    nomeAlunos = (
      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {maa.map((m, i) => (
          <li key={`aluno_${i}_${m.id}`}>
            {m.aluno?.codigo} - {m.aluno?.nomeusual?.trim() || m.aluno?.nome}
          </li>
        ))}
      </ul>
    );
  }

  let labelResponsavel = "Todos os responsáveis";
  let nomeResponsaveis: React.ReactNode | undefined;
  if (mar && mar.length > 0) {
    labelResponsavel = `${mar.length} responsáve${
      mar.length > 1 ? "is" : "l"
    } selecionado${mar.length > 1 ? "s" : ""}`;
    nomeResponsaveis = (
      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {mar.map((m, i) => (
          <li key={`responsavel_${i}_${m.id}`}>
            {m.responsavel?.codigo} - {m.responsavel?.nome}
          </li>
        ))}
      </ul>
    );
  }

  let labelLoginExtra = "Todos os logins do aluno";
  let nomeLoginsExtra: React.ReactNode | undefined;
  if (male && male.length > 0) {
    labelLoginExtra = `${male.length} login${
      male.length > 1 ? "s" : ""
    } de aluno selecionado${male.length > 1 ? "s" : ""}`;
    nomeLoginsExtra = (
      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {male.map((m, i) => (
          <li key={`login_extra_${i}_${m.id}`}>
            {m.loginExtra?.codigo} - {m.loginExtra?.tipo} - {m.loginExtra?.nome}
          </li>
        ))}
      </ul>
    );
  }

  let labelProfessor = "Todos os professores";
  let nomeProfessor: React.ReactNode | undefined;
  if (map && map.length > 0) {
    labelProfessor = `${map.length} professor${
      map.length > 1 ? "es" : ""
    } selecionado${map.length > 1 ? "s" : ""}`;
    nomeProfessor = (
      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {map.map((m, i) => (
          <li key={`login_extra_${i}_${m.id}`}>
            {m.professor?.codigo} - {m.professor?.nome}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <>
      <Typography variant="caption" component="p">
        <b>{quem}</b> - {materia}
      </Typography>
      <Grid container spacing={0.5}>
        {aluno && (
          <Grid item>
            <Tooltip title={nomeAlunos}>
              <Chip size="small" label={labelAluno} />
            </Tooltip>
          </Grid>
        )}
        {responsavel && (
          <Grid item>
            <Tooltip title={nomeResponsaveis}>
              <Chip size="small" label={labelResponsavel} />
            </Tooltip>
          </Grid>
        )}
        {loginExtra && (
          <Grid item>
            <Tooltip title={nomeLoginsExtra}>
              <Chip size="small" label={labelLoginExtra} />
            </Tooltip>
          </Grid>
        )}
        {professor && (
          <Grid item>
            <Tooltip title={nomeProfessor}>
              <Chip size="small" label={labelProfessor} />
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export const RowEnviadaAtribuicao: FC<{
  atribuicoes: IMensagemAtribuicao[];
}> = ({ atribuicoes }) => {
  if (atribuicoes.length == 0) return <></>;

  if (atribuicoes.length == 1) {
    const atr = atribuicoes[0];
    return <AtribuicaoComponent atr={atr} />;
  }

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const atr = atribuicoes[0];
  const demais = atribuicoes.filter((f) => f.id != atr.id);

  return (
    <Grid container spacing={0.5}>
      <Grid item>
        <AtribuicaoComponent atr={atr} />
      </Grid>
      {demais.length > 0 && (
        <Grid item>
          <Chip
            size="small"
            icon={<PlusIcon />}
            label={<Typography variant="caption">{demais.length}</Typography>}
            color="primary"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          />
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
          >
            {atribuicoes.map((atr, i) => (
              <Box key={`atr-${atr.id}-${i}`}>
                <Box sx={{ p: 1 }}>
                  <AtribuicaoComponent atr={atr} />
                </Box>
                {i + 1 < demais.length && <Divider />}
              </Box>
            ))}
          </Popover>
        </Grid>
      )}
    </Grid>
  );
};
